import { useSelector } from 'react-redux'

import { getEnvironment } from '../../utils'
import { Environments } from '../../config/environments'
import { selectTranslate } from '../../reducers/LocaleReducer/LocalReducer'

const NonProdEnvironmentBanner = () => {
  const t = useSelector(selectTranslate)

  return (
    <>
      {getEnvironment() !== Environments.PROD && (
        <div className='environment-banner'>
          {t('warning_environment')}
          <a href='https://app.interneo.pro' rel='noreferrer'>
            {t('warning_production_link')}
          </a>
        </div>
      )}
    </>
  )
}

export default NonProdEnvironmentBanner
